<div class="label-list-container">
	<au-search-input
		class="search-input"
		placeholder="{{ 'search' | translate }}"
		[value]="searchText()"
		(searchTextChanged)="searchText.set($event)"
		(click)="$event.stopPropagation()"
		subscriptSizingMode="dynamic"
	/>
	@for (label of labels() | labelQuickSearch: searchText(); let i = $index; track i) {
		<mat-checkbox
			color="primary"
			class="label-checkbox"
			[checked]="labelsSelection.isSelected(label)"
			(change)="toggleLabel(label)"
		>
			<div class="label-badge-wrapper">
				<label-badge [label]="label" [showCloseButton]="false" />
			</div>
		</mat-checkbox>
	}
</div>
